import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { IDataSourceInfo } from '../../../ts/models/IDataSourceInfo';
import { IWorkbookInfo } from '../../../ts/models/IWorkbookInfo';
import { DataSources } from '../../../ts/resources/Datasources';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { getCommonDatasourceInfo } from '../CommonDatasourceInfo';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { BasicField } from './Elements/BasicField';
import { EntityLinkProps } from './Elements/EntityLink';
import { MarkupField } from './Elements/MarkupField';
import { Name } from './Elements/Name';
import { RelatedEntityList } from './Elements/RelatedEntityList';
import { Tags } from './Elements/Tags';
import { Tooltip } from './Elements/Tooltip';
import { UpdatedAt } from './Elements/UpdatedAt';
import { User } from './Elements/User';
import { ContentTooltipProps, TooltipDescriptionTestId } from './TooltipHelper';


export function WorkbookTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;
  const relatedDatasources = getRelatedDatasourceLinkProps(props.content, props.urls);
  const numSheets = (content as IWorkbookInfo).numSheets;

  return (
    <Tooltip>
      <Name name={content.name} />
      <MarkupField markup={props.content.description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      <Tags tags={props.content.tags} />
      <BasicField name={Messages.sheets()} value={numSheets} />
      <RelatedEntityList label={Messages.column_numDatasources()} list={relatedDatasources} />
      <User user={props.content.owner} label={Messages.owner()} urls={urls} />
      <UpdatedAt value={props.content.updatedAt} />
    </Tooltip>
  );
}

function getRelatedDatasourceLinkProps(workbook: IContentInfo, urls: SpacesSiteUrls): EntityLinkProps[] {
  if (workbook && workbook.hasOwnProperty('datasources')) {
    const datasources: IDataSourceInfo[] = (workbook as any).datasources;
    return datasources.map(ds => {
      const datasourceDetail = getCommonDatasourceInfo(ds);
      return {
        name: ds.name,
        href: urls.exploreWorkbookUrl(workbook.id, 'datasources'),
        iconImagePath: DataSources.getIconForDatasourceType(datasourceDetail, 'medium')
      };
    });
  } else {
    return [];
  }
}
